export const TablitaIcon = ({ minWidth = 20 }: { minWidth?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={minWidth}
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      style={{ display: 'block' }}
    >
      <path
        d="M19.5 15.75C19.5 15.9489 19.421 16.1397 19.2803 16.2803C19.1397 16.421 18.9489 16.5 18.75 16.5H0.75C0.551088 16.5 0.360322 16.421 0.21967 16.2803C0.0790176 16.1397 0 15.9489 0 15.75V0.75C0 0.551088 0.0790176 0.360322 0.21967 0.21967C0.360322 0.0790178 0.551088 0 0.75 0C0.948912 0 1.13968 0.0790178 1.28033 0.21967C1.42098 0.360322 1.5 0.551088 1.5 0.75V9.59719L6.25594 5.4375C6.38536 5.32421 6.54978 5.25885 6.72165 5.25236C6.89353 5.24587 7.06241 5.29866 7.2 5.40188L12.7134 9.53719L18.2559 4.6875C18.3286 4.61556 18.4152 4.55925 18.5105 4.52201C18.6057 4.48478 18.7075 4.46741 18.8097 4.47097C18.9119 4.47454 19.0123 4.49896 19.1047 4.54275C19.1971 4.58653 19.2796 4.64875 19.3471 4.72558C19.4145 4.8024 19.4656 4.89222 19.4971 4.9895C19.5286 5.08678 19.5399 5.18948 19.5302 5.29128C19.5206 5.39307 19.4902 5.49182 19.441 5.58146C19.3918 5.67109 19.3248 5.74972 19.2441 5.8125L13.2441 11.0625C13.1146 11.1758 12.9502 11.2412 12.7783 11.2476C12.6065 11.2541 12.4376 11.2013 12.3 11.0981L6.78656 6.96469L1.5 11.5903V15H18.75C18.9489 15 19.1397 15.079 19.2803 15.2197C19.421 15.3603 19.5 15.5511 19.5 15.75Z"
        fill="currentColor"
      />
    </svg>
  )
}
